import { SystemStatus, SystemsId } from "constants/systems"
import { RootState } from "integrations/redux"

const root = (state: RootState) => state.systems

export const selectHotspotDetectionEngineIsDisabled = (state: RootState): boolean =>
    root(state)[SystemsId.HotspotDetectionEngine] === SystemStatus.Disabled

export const selectClientApplicationId = (state: RootState): string | undefined =>
    root(state).clientConfiguration?.applicationId

export const selectIsInitializingClientApplication = (state: RootState): boolean =>
    root(state).isInitializingClientApplication
